import { render, staticRenderFns } from "./ShortcutModal.vue?vue&type=template&id=3ad49f7d&scoped=true&"
import script from "./ShortcutModal.vue?vue&type=script&lang=js&"
export * from "./ShortcutModal.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutModal.vue?vue&type=style&index=0&id=3ad49f7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad49f7d",
  null
  
)

export default component.exports